import { useRef, useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

const useBannerLogic = () => {
	const containerRef = useRef(null);
	const [bannerHeight, setBannerHeight] = useState(0);

	// multiplication container width * 20.84% to get banner height
	// depending on the browser window width
	const handleSetBannerHeight = () => {
		if (containerRef.current) {
			const height = (containerRef.current.offsetWidth * 20.84) / 100;
			setBannerHeight(height);
		}
	};

	const throttleHandleResize = throttle(handleSetBannerHeight, 1000);

	useEffect(() => {
		handleSetBannerHeight();
	}, [containerRef]);

	useEffect(() => {
		window.addEventListener('resize', throttleHandleResize);

		return () => {
			window.removeEventListener('resize', throttleHandleResize);
		};
	});

	return { containerRef, bannerHeight };
};

export default useBannerLogic;
